<template>
  <div>
    <lego-segment-wrapper :small="small" :medium="medium" v-model="model.value">
      <lego-segment-button
          v-for="item in optionData"
          :key="item.value"
          :value="item.value"
          @click="onClick(item.value)"
          :disabled="disabled"
      >
        {{ item.text }}
      </lego-segment-button>
    </lego-segment-wrapper>
  </div>
</template>

<script>
export default {
  name: 'ScpmTableSegmentV2',
  props: ['value', 'itemKey', 'tableIdx', 'disabled', 'optionItems', 'small', 'medium'],
  emits: ['click'],
  watch: {
    value(value) {
      this.model.value = value
    }
  },
  methods: {
    onClick(value) {
      this.$emit('click', {
        ...(this.itemKey && {itemKey: this.itemKey}),
        ...(this.tableIdx && {tableIdx: this.tableIdx}),
        statusValue: value
      });
    }
  },
  data() {
    return {
      model: {
        value: String(this.value)
      },
      policyItems: [
        {value: 'N', text: this.$t('button.eventActive')},
        {value: 'Y', text: this.$t('button.deactive')}
      ]
    };
  },
  computed: {
    optionData() {
      if (this.optionItems) {
        return this.optionItems;
      }
      return this.policyItems;
    }
  }
};
</script>

<style lang="scss" scoped>
:deep {
  .lego-segment-button--disabled.lego-segment-button--checked {
    background-color: #EFF1FB !important;
    border-color: #BBC3EC !important;
    color: #BBC3EC !important;
  }
}
</style>